import { render, staticRenderFns } from "./WordDetail.vue?vue&type=template&id=28297cea&scoped=true&lang=pug"
import script from "./WordDetail.vue?vue&type=script&lang=ts"
export * from "./WordDetail.vue?vue&type=script&lang=ts"
import style0 from "./WordDetail.vue?vue&type=style&index=0&id=28297cea&prod&lang=stylus&scoped=true"
import style1 from "./WordDetail.vue?vue&type=style&index=1&id=28297cea&prod&lang=stylus&scoped=true"
import style2 from "./WordDetail.vue?vue&type=style&index=2&id=28297cea&prod&lang=stylus&scoped=true"
import style3 from "./WordDetail.vue?vue&type=style&index=3&id=28297cea&prod&lang=stylus&scoped=true"
import style4 from "./WordDetail.vue?vue&type=style&index=4&id=28297cea&prod&lang=stylus&scoped=true"
import style5 from "./WordDetail.vue?vue&type=style&index=5&id=28297cea&prod&lang=stylus&scoped=true"
import style6 from "./WordDetail.vue?vue&type=style&index=6&id=28297cea&prod&lang=stylus&scoped=true"
import style7 from "./WordDetail.vue?vue&type=style&index=7&id=28297cea&prod&lang=stylus&scoped=true"
import style8 from "./WordDetail.vue?vue&type=style&index=8&id=28297cea&prod&lang=stylus&scoped=true"
import style9 from "./WordDetail.vue?vue&type=style&index=9&id=28297cea&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28297cea",
  null
  
)

export default component.exports